export const LogoMark = ({ className = "h-10 w-10" }) => (
  <svg viewBox="0 0 48 48" className={className} fill="none" aria-hidden="true">
    <rect width="48" height="48" rx="13" fill="#123A3E" />
    <path
      d="M31.6 34.8a12.4 12.4 0 0 1-8.4-21.6c.56-.5 1.44 0 1.26.75a9.7 9.7 0 0 0 12.52 11.5c.71-.22 1.27.67.76 1.22a12.3 12.3 0 0 1-6.14 8.13Z"
      fill="#FAF8F5"
    />
    <path
      d="M15.4 13.6l1.25 3.05 3.05 1.25-3.05 1.25L15.4 22.2l-1.25-3.05-3.05-1.25 3.05-1.25 1.25-3.05Z"
      fill="#E6DEC8"
    />
  </svg>
);

export const Logo = ({ light = false, onClick }) => (
  <button
    onClick={onClick}
    data-testid="navbar-brand-logo"
    className="flex items-center gap-3 group"
    aria-label="Kaisan koto – etusivulle"
  >
    <LogoMark className="h-10 w-10 transition-transform duration-500 group-hover:rotate-[-8deg]" />
    <span className="flex flex-col items-start leading-none">
      <span className={`font-serif text-[1.5rem] font-semibold tracking-tight ${light ? "text-cream" : "text-petrol"}`}>
        Kaisan koto
      </span>
      <span className={`text-[0.58rem] font-semibold tracking-[0.3em] uppercase mt-1 ${light ? "text-cream/60" : "text-mutedink"}`}>
        Lastenhoitoa iltoihin & viikonloppuihin
      </span>
    </span>
  </button>
);
